export const USUAL_CARE_USER_CODE = 'usual_care';
export const THERAPY_MATCH_D_USER_CODE = 'therapy_match_d';
export const THERAPIST_CATEGORIES = {
  [USUAL_CARE_USER_CODE]: 'Usual Care',
  [THERAPY_MATCH_D_USER_CODE]: 'StratCare',
};
